import Helper from "./Helper";

class StoryHover {
  constructor() {
    this.storiesSelector = ".ns-stories__story";
    this.imageSelector = ".ns-stories__img--desktop";
    this.titleSelector = ".ns-stories__story-title";

    this.breakpoint = 768;
    this.currentScreenWidth = window.innerWidth;
    this.previousScreenWidth = window.innerWidth;
    this.currentlyDesktop = null;
    this.isInited = false;
    this.body = document.querySelector("body");

    this.stories = Array.prototype.slice.call(
      document.querySelectorAll(this.storiesSelector)
    );

    if (this.stories.length != 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    if (this.currentScreenWidth < this.breakpoint) {
      this.currentlyDesktop = false;
      // console.log("currently mobile");
    } else {
      this.currentlyDesktop = true;
      // console.log("currently desktop");
      this.initStoryHover();
    }

    window.addEventListener("resize", () => {
      const vw = window.innerWidth;

      if (this.previousScreenWidth < this.breakpoint) {
        if (vw > this.breakpoint) {
          // console.log("breakpoint change now desktop");
          this.initStoryHover();
        }
      }

      if (this.previousScreenWidth > this.breakpoint) {
        if (vw < this.breakpoint) {
          // console.log("breakpoint change now mobile");
          this.destroyStoryHover();
        }
      }

      this.previousScreenWidth = vw;
    });
  }

  initStoryHover() {
    Helper.addClass(this.body, "story-hover-active");
    this.stories.forEach((story) => {
      this.buildHoverStuff(story);
    });
  }

  destroyStoryHover() {
    Helper.removeClass(this.body, "story-hover-active");
    this.stories.forEach((story) => {
      this.destroyHoverStuff(story);
    });
  }

  buildHoverStuff(story) {
    const title = story.querySelector(this.titleSelector);
    const img = story.querySelector(this.imageSelector);
    let imgURL = img.src;
    if(!imgURL){
      imgURL = img.dataset.src;
    }
    const wrapper = document.createElement("div");
    const hoverImg = document.createElement("div");
    Helper.wrap(story, wrapper);
    Helper.addClass(wrapper, "js-story-link-wrapper");
    Helper.addClass(hoverImg, "hoverImg");
    hoverImg.innerHTML = `<img src="${imgURL}">`;
    wrapper.prepend(hoverImg);

    title.addEventListener("mousemove", (e) => {
      hoverImg.style.left = e.pageX + "px";
      hoverImg.style.top = e.pageY + "px";
    });
    title.addEventListener("mouseenter", (e) => {
      Helper.addClass(hoverImg, "hoverImg--in");
      Helper.removeClass(hoverImg, "hoverImg--out");
      hoverImg.style.left = e.pageX + "px";
      hoverImg.style.top = e.pageY + "px";
    });
    title.addEventListener("mouseleave", (e) => {
      Helper.addClass(hoverImg, "hoverImg--out");
      Helper.removeClass(hoverImg, "hoverImg--in");
    });
  }

  destroyHoverStuff(story) {
    story.previousElementSibling.remove();
    Helper.unwrapNode(story.parentNode);
  }
}

export default StoryHover;
